import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper';
import ShuffleText from 'shuffle-text';
import mapboxgl from 'mapbox-gl';
import Player from '@vimeo/player';


function checkDeviceType() {
    var browserWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0;
    return browserWidth < 768 ? 'mobile' : 'pc';
}


function init_video() { 

  const video = document.getElementById('top-video');
  if (video === null) return null;

  const deviceType = checkDeviceType();
  
  let options_device = {};
  let options_common = {
    loop: true,
    background: true,
    muted: true,
    responsive: true,
  }

  switch (deviceType) {
    case 'mobile':
      options_device = {
        id: 936823460,
        width: 480,
        height: 720,
        quality: '1080p'
      };
      break;
    case 'pc':
      options_device = {
        id: 936823470,
        width: 1440,
        height: 810,
      };
      break;
  }

  const options = Object.assign({}, options_device, options_common);

  // console.debug(options);

  const vimeoPlayer = new Player('top-video', options);
  return vimeoPlayer;
}

const background_video = init_video();



let timerId, startPos = 0, winScrollTop = window.scrollY;

gsap.registerPlugin(ScrollTrigger);
gsap.fromTo(".top-about", {
  autoAlpha: 0,
}, {
  autoAlpha: 1,
  duration: 1,
  scrollTrigger: {
    trigger: ".top-about",
    toggleActions: "play pause resume reverse",
    pin: true,
    anticipatePin: 1,
  },
});

// gsap.fromTo(".video-02", {
//     yPercent: 50,
// }, {
//   yPercent: -50,
//   ease: "none",
//   scrollTrigger: {
//     trigger: ".top-about",
//     start: "top bottom",
//     end: "bottom top",
//     scrub: 2,
//   },
// });

// gsap.fromTo(".video-01", {
//     yPercent: -50,
// }, {
//   yPercent: 50,
//   ease: "none",
//   scrollTrigger: {
//     trigger: ".top-about",
//     start: "top bottom",
//     end: "bottom top",
//     scrub: 3,
//   },
// });


// スクロールでパララックス
var parallax_target = gsap.utils.toArray(".js-parallax");
if (parallax_target.length > 0) { 
  parallax_target.forEach((target, index) => {
    
    let yPercent = 20;
    // console.debug(target.dataset.yPercent);

    if (typeof target.dataset.yPercent !== 'undefined') {
      yPercent = target.dataset.yPercent;
    }
    
    gsap.timeline({
      scrollTrigger: {
        trigger: target,
        start: "top 70%",
        end: "bottom center",
        toggleActions: "play none none reverse",
        scrub: 3,
      }
    })
    .fromTo(target, {
      yPercent: yPercent,
    }, {
      yPercent: 0,
    })
  });
}


// スクロールでフェードイン
var fadein_target = gsap.utils.toArray(".js-fadein");
if (fadein_target.length > 0) { 
  fadein_target.forEach( (target, index) => {

    gsap.timeline({
      scrollTrigger: {
        trigger: target,
        start: "top 70%",
        end: "bottom center",
        toggleActions: "play none none reverse",
        // markers: true,
      }
    })
    .fromTo(target, {
      autoAlpha: 0,
      yPercent: 5,
    }, {
      autoAlpha: 1,
      yPercent: 0,
      duration: .6,
    })

  });
}

const site_main = document.querySelector('.js-opening-main');
gsap.registerEffect({
  name: 'siteOpening',
  effect: (targets, config) => {
    return gsap.fromTo(targets, {
      autoAlpha: 0,
      y: 30,
    }, {
      duration: config.duration,
      autoAlpha: 1,
      y: 0,
      onComplete: triggerShuffleText()
    });
  }
});

function mobileMenu() { 

  const navigationMenu = document.getElementById('navigation-menu');
  const navigationMenuToggle = document.getElementById('navigation-menu-toggle');

  const navigationMenuList = navigationMenu.querySelectorAll('.menu-item');

  navigationMenuToggle.addEventListener('click', function (e) {
    clearTimeout(timerId);
    // console.debug('click');
    if (document.body.dataset.navigation === 'open') {
      document.body.dataset.navigation = 'close';
    } else {
      document.body.dataset.navigation = 'open';
    }
  });

}

function triggerShuffleText() { 

  setTimeout(() => {
    const shuffle_text = document.querySelectorAll('.js-shuffle-text');

    // shuffle_text のCSSで opacity を 1 に変更する
    shuffle_text.forEach(function (el) {

      el.style.opacity = 1;
      var text = new ShuffleText(el);
      text.duration = 1200;
      text.start();

    });

  }, 800);

}


function init() { 

  mobileMenu();

  const per_view = 4.5;
  // const per_view_sp = 3;
  const slide_news_langth = document.querySelectorAll('.slide-news .swiper-slide').length;
  let loop_flag = false;
  if (slide_news_langth > per_view) {
    loop_flag = true;
  }
  // console.debug(slide_news_langth);

  const swiper = new Swiper('.slide-news', {

    slidesPerView: 1.5,
    centeredSlides: true,
    spaceBetween: 28,
    grabCursor: true,
    speed: 600,
    // loop: loop_flag,
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false
    // },
    breakpoints: {
      // when window width is >= 768px
      768: {
        slidesPerView: per_view,
        slidesPerGroup: 3,
        spaceBetween: 40,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  })
}
document.addEventListener("DOMContentLoaded", init);



window.addEventListener('load', function (e) { 


  if (background_video !== null) { 

    background_video.on('loaded', function () { 
      // console.debug('loaded');
      background_video.pause();
      setTimeout(() => {
        background_video.play();
        background_video.element.classList.add('video-main');
      }, 2000); 
    });

  }

  gsap.effects.siteOpening(site_main, {
    duration: 1.5,
  });

  document.body.dataset.loading = "done";


});



window.addEventListener('scroll', function (e) { 

    winScrollTop = window.pageYOffset;
    winHeight = window.innerHeight;

    // console.debug(winScrollTop);
    if (winScrollTop > 1) {
      document.body.dataset.scroll = "scrolled";
    } else { 
      document.body.dataset.scroll = "unscroll";
    }

    if ( startPos < winHeight * .5 || winScrollTop <= 0) {
      document.body.dataset.view = "first";
    } else { 
      document.body.dataset.view = "second";
    }

    if ( startPos < winHeight * 3 || winScrollTop <= 0) {

      if (background_video !== null) background_video.play();

    } else { 

      if (background_video !== null) background_video.pause();

    }

    startPos = winScrollTop;
  // }, 100);
  return false;
});


const mapWrapper = document.getElementById('map');
if(typeof mapWrapper !== 'undefined' && mapWrapper !== null) {

  const lnglat = [139.75319559580055, 35.65920351355206];
  const loadImagePath = '/wp-content/themes/wp-theme-geekerslabo/assets/images/common/logo_map.webp';

  mapboxgl.accessToken = 'pk.eyJ1IjoiZGFsZGV2ZWxvcG1lbnQiLCJhIjoiY2xyaWhmM2Q3MGFjOTJscXA1Zm5rc21wcyJ9.oD4boK36r3Cy4jjwejXFUw';

  const map = new mapboxgl.Map({
    container: 'map', // container ID
    style: 'mapbox://styles/daldevelopment/clo53mqsd005x01rcc44d50zr', // style URL
    center: lnglat, // starting position [lng, lat]
    zoom: 17, // starting zoom
  });

  map.on('load', () => {
    // Load an image from an external URL.
    map.loadImage(
      loadImagePath,
      (error, image) => {
        if (error) throw error;
        
        // Add the image to the map style.
        map.addImage('logo', image);
        
        // Add a data source containing one point feature.
        map.addSource('point', {
          'type': 'geojson',
          'data': {
            'type': 'FeatureCollection',
            'features': [{
              'type': 'Feature',
              'geometry': {
                'type': 'Point',
                'coordinates': lnglat
              }
            }]
          }
        });

        // Add a layer to use the image to represent the data.
        map.addLayer({
          'id': 'points',
          'type': 'symbol',
          'source': 'point', // reference the data source
          'layout': {
            'icon-image': 'logo', // reference the image
            'icon-size': 0.5
          }
        });

        map.scrollZoom.disable();
      }
    );
  });

}
